module.exports = __webpack_public_path__ + "static/media/contacts_play.e2a4f6fd.svg";